export default {
    props: ['studyId'],
    data(){
        return {
            id:'',
            audiourl:'',
            currentTime:'',
            duration:'',
            maxTime:0,
            maxlongTime:0,
            progress:0,
        }
    },
    methods:{
        getResourse(){
            this.$post('resources/get',{id:this.id,token:this.$store.state.id}).then(res=>{
               this.audioPlay(res.data.result.data) 
                // this.videoPlay(url)
                // console.log( this.audiourl)
            });
        },
        audioPlay(url){
            this.audiourl = this.musicUrl+url
        },
        getDuration() {
            // console.log(this.$refs.audio.duration); //此时可以获取到duration
            this.duration = this.$refs.audio.duration;
            this.duration = this.timeResult(this.duration);
         },
        updateTime(e) {
            this.currentTime = e.target.currentTime;  //获取audio当前播放时间
            // console.log('当前时间' + this.currentTime);
            this.maxTime = this.currentTime>=this.maxTime?this.currentTime:this.maxTime
            // console.log('最大时间'+ this.maxTime)
            this.maxlongTime = this.timeResult(this.maxTime)
            this.progress = this.maxTime/this.currentTime
            // console.log('进度'+this.progress)
            
         },
         timeResult: function (time) {
            //  console.log(time)
            let secondTime = Number.parseInt(time);
            let minuteTime = 0;
            let hourTime = 0;
            let result = '';
            if (time > 60) {
                minuteTime = Number.parseInt(time / 60);
                secondTime = Number.parseInt(time % 60);
                if (minuteTime > 60) {
                    hourTime = Number.parseInt(minuteTime / 60);
                    minuteTime = Number.parseInt(minuteTime % 60);
                }
            }
            hourTime >= 10 ? result += hourTime + '时' : result += '0' + hourTime + '时';
            minuteTime >= 10 ? result += minuteTime + '分' : result += '0' + minuteTime + '分';
            secondTime >= 10 ? result += secondTime + '秒' : result += '0' + secondTime + '秒';
            return result;
        },
     
    },
    created(){
        this.id = this.studyId;
    },
    mounted(){
        this.getResourse();
    },
    watch: {
        
    }
}